module.exports = __webpack_public_path__ + "static/media/lang9.c4528c68.mp3";